import { render, staticRenderFns } from "./CancelationPolicyItemEdit.vue?vue&type=template&id=67331245&scoped=true&"
import script from "./CancelationPolicyItemEdit.vue?vue&type=script&lang=js&"
export * from "./CancelationPolicyItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67331245",
  null
  
)

export default component.exports